import * as React from 'react';
import { OrganisationPledge } from '@shapeable/kelp-forest-alliance-types';

export const OrganisationPledgesContext = React.createContext<OrganisationPledge[]>(null);
export const OrganisationPledgesProvider = OrganisationPledgesContext.Provider;
